var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAsideGraphTemplates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 18.5L9.67269 13.7714C9.8024 13.5419 9.91628 13.3404 10.0182 13.1622M10.0182 13.1622C10.3341 12.6097 10.535 12.2806 10.7358 12.0336C12.3978 9.98851 15.3618 9.58448 17.5106 11.1101C17.8516 11.3522 18.2309 11.7309 18.985 12.485M10.0182 13.1622L9.5 13C8.30448 12.7609 7.70672 12.6413 7.15808 12.653C5.68985 12.6842 4.30956 13.3593 3.38354 14.4991C3.03751 14.925 2.76489 15.4702 2.21965 16.5607L2.10982 16.7804L1.98875 16.9849M18.985 12.485C19 11.7605 19 10.939 19 10C19 6.25027 19 4.3754 18.0451 3.06107C17.7367 2.6366 17.3634 2.26331 16.9389 1.95491C15.6246 1 13.7497 1 10 1C6.25027 1 4.3754 1 3.06107 1.95491C2.6366 2.26331 2.26331 2.6366 1.95491 3.06107C1 4.3754 1 6.25027 1 10C1 13.7497 1 15.6246 1.95491 16.9389C1.96611 16.9543 1.97738 16.9697 1.98875 16.9849M18.985 12.485C18.9401 14.6536 18.7609 15.9537 18.0451 16.9389C17.7367 17.3634 17.3634 17.7367 16.9389 18.0451C15.6246 19 13.7497 19 10 19C6.25027 19 4.3754 19 3.06107 18.0451C2.652 17.7479 2.29047 17.3904 1.98875 16.9849M7 7C7 8.10457 7.89543 9 9 9C10.1046 9 11 8.10457 11 7C11 5.89543 10.1046 5 9 5C7.89543 5 7 5.89543 7 7Z",
    stroke: "#C2C2C2",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsideGraphTemplates);
export default __webpack_public_path__ + "static/media/aside-graph-templates.62fa8d5d8586bbebee24fcdae9eef014.svg";
export { ForwardRef as ReactComponent };